<template>
    <section>
      <!-- Componentes externos -->
      <!-- <PersonaHorario />
      <AsignarHorarioEspecial />
      <asignar-horario />
      <VerHorarioEspecial />
      <VerHorarioContinuoDiscontinuo /> -->


      <!-- <h3 class="primary--text">
        <v-icon color="primary">business</v-icon> Lista de personas con sus
        horarios correspondientes
      </h3> -->
   
      <v-card>
        <v-card-text>
          <v-tooltip bottom>
            <v-btn
              color="primary"
              dark
              @click.native.stop="asignarHorario()"
              slot="activator"
              ><v-icon dark>add</v-icon> Asignar Horarios</v-btn
            >
            <span>Nueva Asignación</span>
          </v-tooltip>
          <!-- Boton filtro -->
          <v-tooltip bottom>
            <v-btn
              @click.native="
                () => {
                  filterShow = filterShow ? false : true;
                }
              "
              class="btn-refresh"
              slot="activator"
              ><v-icon>filter_list</v-icon>
            </v-btn>
            <span>Búsqueda/filtros</span>
          </v-tooltip>
          <!-- Boton acutualizar -->
          <v-tooltip bottom>
            <v-btn
              @click.native="cargarPersonasHorarios()"
              class="btn-refresh"
              slot="activator"
              ><v-icon>refresh</v-icon>
            </v-btn>
            <span>{{ $t("common.updateList") }}</span>
          </v-tooltip>
          <v-flex xs12>
            <transition name="slide-fade">
              <div class="filter-container-rrhh" v-show="filterShow">
                <v-icon small color="primary">search</v-icon>
  
                <div class="filter-item">
                  <v-text-field
                    label="Nombres"
                    type="text"
                    v-model="form.nombres"
                    @input="filterNombres(form.nombres)"
                  ></v-text-field>
                </div>
                <div class="filter-item">
                  <v-text-field
                    label="Ap paterno"
                    type="text"
                    v-model="form.ap_paterno"
                    @input="filterPaterno(form.ap_paterno)"
                  ></v-text-field>
                </div>
                <div class="filter-item">
                  <v-text-field
                    label="Ap materno"
                    type="text"
                    v-model="form.ap_materno"
                    @input="filterMaterno(form.ap_materno)"
                  ></v-text-field>
                </div>
                <!-- botones cerrar -->
                <div class="btn-filter">
                  <v-tooltip bottom>
                    <v-btn icon small slot="activator" @click.native="recargar()">
                      <v-icon small>refresh</v-icon>
                    </v-btn>
                    <span>Recargar filtros</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <v-btn
                      icon
                      slot="activator"
                      @click.native="
                        () => {
                          filterShow = false;
                          recargar();
                        }
                      "
                    >
                      <v-icon small>close</v-icon>
                    </v-btn>
                    <span>Cerrar filtros</span>
                  </v-tooltip>
                </div>
              </div>
            </transition>
          </v-flex>
          <!-- <crud-table
            :headers="headers"
            :url="url"
            :filters="filters"
            :data-graphql="dataGraphql"
            :graphql="graphql"
          > 
          :search="filters"
            :custom-filter="customFilter"
          -->
  
          <!-- Template injectable de la cabecera de la tabla -->
          <v-data-table
            :headers="headers"
            :items="l_horarios_personas"
            class="elevation-1"
            :pagination.sync="pagination"
            :no-data-text="loading ? 'Cargando...' : 'No se tiene registros'"
            :disable-initial-sort="true"
            no-results-text="No se encontraron coincidencias"
            :loading="loading"
            :search="filters"
            :custom-filter="customFilter"
            :rows-per-page-items="[10, 25, { text: 'Todos', value: -1 }]"
          >
            <template v-slot:headers="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : ''
                  ]"
                  id="cabecera_tabla"
                  @click="changeSort(header.value)"
                >
                  <v-icon small color="white">arrow_upward</v-icon>
                  {{ header.text }}
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="items">
              <td>
                {{ items.item.ap_paterno }}
                {{ items.item.ap_materno }} {{ items.item.nombres }} <br />
                <v-chip
                  small
                  color="rgb(0, 134, 191)"
                  dark
                  style="font-size :0.8em;"
                  >CI: {{ items.item.nro_doc }}</v-chip
                >
              </td>
              <td>
                <span v-if="items.item.horarios.length === 0"
                  >NO TIENE HORARIOS ASIGNADOS</span
                >
                <v-expansion-panel>
                  <v-expansion-panel-content
                    class="panel-reducido"
                    v-for="horario in items.item.horarios"
                    :key="horario.id"
                  >
                    <template v-slot:header>
                      <div>
                        {{ horario.descripcion }}:
                        {{
                          $moment(horario.hora_inicio, "HH:mm:ss").format("HH:mm")
                        }}
                        -
                        {{
                          $moment(horario.hora_fin, "HH:mm:ss").format("HH:mm")
                        }}
                      </div>
                    </template>
                    <v-card>
                      <v-card-text class="p-1">
                        <v-layout wrap row class="text-xs-center">
                          <v-flex xs12 md6>
                            <b class="blue--text">Hora inicio: </b>
                            {{ horario.hora_inicio }}
                          </v-flex>
                          <v-flex xs12 md6>
                            <b class="blue--text">Hora fin: </b> {{ horario.hora_fin }}
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </td>
              <td class="text-xs-center">
                {{
                  items.item.horario_personas.length > 0
                    ? $moment(items.item.horario_personas[0].fecha_desde).format(
                        "DD/MM/YYYY"
                      )
                    : ""
                }}
              </td>
              <td class="nowrap text-xs-center">
                <v-tooltip bottom>
                  <v-btn
                    color="primary"
                    icon
                    slot="activator"
                    @click.native="personaHorario(items.item)"
                    dark
                  >
                    <v-icon>add_circle_outline</v-icon>
                  </v-btn>
                  <span>Asignar Horario</span>
                </v-tooltip>
                <!--  ver horario continuo-discontinuo-->
                <v-tooltip bottom>
                  <v-btn
                    color="primary"
                    icon
                    slot="activator"
                    @click.native="verHorarioContinuoDiscontinuo(items.item)"
                    dark
                  >
                    <v-icon>visibility</v-icon>
                  </v-btn>
                  <span>Ver historico de horarios</span>
                </v-tooltip>
                <!-- <v-tooltip bottom>
                  <v-btn
                    color="orange"
                    icon
                    slot="activator"
                    @click.native="personaHorarioEspecial(items.item)"
                    dark
                  >
                    <v-icon>event_note</v-icon>
                  </v-btn>
                  <span>Asignar Horario Especial</span>
                </v-tooltip> -->
                <!--  ver horario especial-->
                <!-- <v-tooltip bottom>
                  <v-btn
                    color="orange"
                    icon
                    slot="activator"
                    @click.native="verHorariosEspeciales(items.item)"
                    dark
                  >
                    <v-icon>visibility</v-icon>
                  </v-btn>
                  <span>Ver horarios especiales</span>
                </v-tooltip> -->
              </td>
            </template>
  
            <template v-slot:expand="props">
              <v-card flat>
                <v-card-text>{{ props.item.nombres }}</v-card-text>
              </v-card>
            </template>
          </v-data-table>
          <!-- </crud-table> -->
        </v-card-text>
      </v-card>
    </section>
  </template>
  
  <script>

  // import AsignarHorario from "../dialogs/AsignarHorario"; // Componente de creación y actualización
  // import PersonaHorario from "../dialogs/PersonaHorario"; // Componente de creación y actualización
  // import AsignarHorarioEspecial from "../dialogs/AsignarHorarioEspecial";
  // import VerHorarioEspecial from "../dialogs/VerHorarioEspecial";
  // import VerHorarioContinuoDiscontinuo from "../dialogs/VerHorarioContinuoDiscontinuo";
  import Filtros from "../mixins/Filtros";
  export default {
    // Importación de métodos y funciones de un archivo mixin
    mixins: [Filtros],
    props:{
      l_id_tipo_persona: {
      type: Array,
      default: null
    }
  },
    // Variables iniciales del componente
    data() {
      return {
        pagination: {
          sortBy: ""
        },
        url: "personas",
        graphql: true,
        // Cabecera de la tabla
        headers: [
          { text: "Nombre completo", value: "nombre_completo" },
          { text: "Horarios", value: "-", sortable: false },
          { text: "Fecha desde", value: "fecha_desde", sortable: false },
          { text: this.$t("common.actions"), sortable: false, align: "center" }
        ],
        // Campos solicitados de Graphql(Agregar los que necesite)
        dataGraphql: `
          id
          id_estado
          nombres
          ap_paterno
          ap_materno
          horarios{
            id
            descripcion
            hora_inicio
            hora_fin
            rango_inicio
            rango_fin
            tipo_inicio
            tipo_fin
          }
          horario_personas{
            id
            fecha_desde
            id_horario
          }
          _user_created
          _user_updated
          _created_at
          _updated_at
        `,
        // Filtros del componente CrudTable ejemplo:
        filters: [
          {
            field: "nombres",
            label: "Nombres",
            type: "text", // Tipo de input en el filtro
            typeG: "String" // Tipo definido en Graphql
          },
          {
            field: "ap_paterno",
            label: "Apellido paterno",
            type: "text", // Tipo de input en el filtro
            typeG: "String" // Tipo definido en Graphql
          },
          {
            field: "ap_materno",
            label: "Apellido materno",
            type: "text", // Tipo de input en el filtro
            typeG: "String" // Tipo definido en Graphql
          }
        ],
        l_horarios_personas: [],
        loading: false,
        // Variables filtros
        form: {},
        filters: {
          nombres: "",
          ap_paterno: "",
          ap_materno: ""
        },
        filterShow: true
      };
    },
    async created() {
      await this.cargarPersonasHorarios();
    },
    // Funcionalidades que se ejecutan al montar el componente
    async mounted() {
      // Verificando si el usuario tiene permiso para interactual con el componente
      // const rolesPermitidos = [128]; // ID's de roles permitidos
      // if (!this.$util.permisoRol(rolesPermitidos)) {
      //   this.$router.push("/403");
      // }
      this.$bus.$on("closeDialog", async () => {
        await this.cargarPersonasHorarios();
      });
      this.$bus.$on("closeDialogAsignacionHorario", async () => {
        await this.cargarPersonasHorarios();
      });
    },
    // Métodos y funciones del componente
    methods: {
      // Metodo para ordenar la tabla
      changeSort(column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }
      },
      // Metodo para cargar el listado de horarios
      async cargarPersonasHorarios() {
        this.loading = true;
        try {
          let res = await this.$service.graphql({
            query: `
              query{
                vHorariosPersonaGenerals(l_tipo_persona:${JSON.stringify(
                  this.l_id_tipo_persona
                )}){
                  rows{
                    id
                    id_estado
                    nombres
                    ap_paterno
                    ap_materno
                    nro_doc
                    horario_personas
                    horarios
                  }
                }
              }
            `
          });
          let lista_tmp = res.vHorariosPersonaGenerals.rows;
          // Transformamos objetos JSON
          lista_tmp.forEach(element => {
            element.horario_personas = JSON.parse(element.horario_personas);
            element.horarios = JSON.parse(element.horarios);
            element.nombre_completo = `${element.ap_paterno} ${element.ap_materno} ${element.nombres}`;
          });
          this.l_horarios_personas = lista_tmp;
        } catch (error) {
          console.log(error);
        }
        this.loading = false;
      },
      asignarHorario() {
        this.$bus.$emit("openDialogAsignarHorario");
      },
      personaHorario(item) {
        this.$bus.$emit("openDialogPersonaHorario", item);
      },
      personaHorarioEspecial(item) {
        this.$bus.$emit("openDialogAsignacionEspecial", item);
      },
      verHorariosEspeciales(item) {
        this.$bus.$emit("openDialogVerHorarioEspecial", item);
      },
      verHorarioContinuoDiscontinuo(item) {
        this.$bus.$emit("openDialogVerHorarioContinuoDiscontinuo", item);
      },
      async verificarHorarioEspecial(item) {
        let resultado;
        try {
          if (item.horario_personas[0]) {
            let res = await this.$service.graphql({
              query: `
              query{
                personaHorarioDiass(id_horario_persona:${parseInt(
                  item.horario_personas[0].id
                )},id_estado:1){
                  rows{
                    id
                  }
                }
              }
            `
            });
            let respuesta = res.personaHorarioDiass.rows;
            if (respuesta.length > 0) {
              resultado = true;
            } else {
              resultado = false;
            }
          } else {
            resultado = false;
          }
          return resultado;
        } catch (error) {
          console.log(error);
        }
      }
    },
    // Definición de componentes importados
    components: {
      // AsignarHorario,
      // PersonaHorario,
      // AsignarHorarioEspecial,
      // VerHorarioEspecial,
      // VerHorarioContinuoDiscontinuo
    }
  };
  </script>
  
  <style lang="scss">
  .panel-reducido {
    .v-expansion-panel__header {
      padding: 0em 1em 0em 1em;
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/admin/asignacion_horario/components/ListadoPasantes.vue